<template>
  <div>
    <b-modal id="mass-assignments-modal" no-close-on-backdrop
             :modal-class="`adp-big-modal adp-big-modal__no_footer`"
             :body-class="`adp-big-modal-body`" :header-class="`adp-big-modal-header`">

      <template #modal-header>
        <button class="btn adp-btn" @click="checkAssign">{{ $t('catalog.assign') }}</button>

        <div class="d-flex align-items-center ml-4 position-relative align-self-center">
          <span class="adp-p adp-p__bold mr-2">{{ $t('catalog.assign_as') }}</span>
          <activity-type-select :options="groups" :init-selected="group" v-on:my-change="selectType($event)">
          </activity-type-select>
        </div>

        <button type="button" class="close adp-close" data-dismiss="modal" aria-label="Close" @click="close">
          <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
        </button>
      </template>
      <template #modal-header-close>

      </template>
      <template>
        <div class="mass-assignments-modal-back" @click="close">
          <img class="mass-assignments-modal-back--icon" src="/images/arrow_back.svg" alt="">
        </div>
        <div class="mass-assignments-modal-group">
          <div class="d-flex align-items-center ml-3 mt-3 position-relative align-self-center">
            <span class="adp-p adp-p__bold mr-2">{{ $t('catalog.assign_as') }}</span>
            <activity-type-select :options="groups" :init-selected="group" v-on:my-change="selectType($event)">
            </activity-type-select>
          </div>
        </div>
        <div class="mass-assignments-modal-search">
          <template>
            <div class="d-flex">
              <div class="custom-control custom-checkbox menu-label mass-assignments-modal-search--checkbox"
                   :class="{'partial-checked': partialChecked}" @click="toggleCheckedSearch">
                <input type="checkbox" class="custom-control-input" v-model="allChecked" value="1" checked>
                <span class="custom-control-label" style="cursor: pointer">{{ '' }}</span>
              </div>
              <div class="d-flex flex-column mass-assignments-modal-search--search">
                <span class="adp-th">{{ $t('catalog.assign_search_group') }}</span>
                <input type="text" class="adp-input adp-input__catalog adp-input-search" v-model="search">
              </div>
            </div>
          </template>
        </div>
        <div class="mass-assignments-modal-block">
          <div class="adp-big-modal-row">
            <structure-tree v-if="checkedItems[company.id]"
                            v-for="(company, key) in companies"
                            :key="company.id"
                            :search="search"
                            :parent="company"
                            :label="company.name"
                            :open="false"
                            :preset-values="{}"
                            :parentChecked="checkedItems[company.id].checked"
                            :parentShowMobile="checkedItems[company.id].showMobile"
                            :parentLevel="0"
                            :checkedItems="checkedItems[company.id]"
                            @toggleMobile="toggleMobile"
                            @updateItemsSearch="updateItemsSearch"
                            @updateItemsChecked="updateItemsChecked">
            </structure-tree>
          </div>
          <div class="mass-assignments-modal-block--assign">
            <button class="btn adp-btn" @click="checkAssign">{{ $t('catalog.assign') }}</button>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal id="alert-assignments-modal" hide-footer
             :modal-class="`adp-modal adp-modal__no_footer mass-assignments-alert-modal`"
             :body-class="`adp-modal-body`">
      <template #modal-header-close>
        <button type="button" class="close adp-close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
        </button>
      </template>
      <template>
        <div class="mass-assignments-alert">
          {{ $t('catalog.mass_assign_alert_1') }} "{{ assignedActivitiesText }}" {{ $t('catalog.mass_assign_alert_2') }}
          <br><br>
          <div v-for="(activityUsers, activityKey) in userAssignments" class="mb-4">
            <p v-for="(user, index) in activityUsers" class="mass-assignments-alert__item">
              ({{ user.pernumber }}) {{ user.surname }} {{ user.name }}
            </p>
          </div>
          <button class="btn float-right mb-2" style="margin-right: -60px; color: #E6C600" @click="goToAssignments">
            {{ $t('catalog.view_assignment') }}
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal id="alert-assignments-modal-list" hide-footer
             :modal-class="`adp-modal adp-modal__no_footer`" :body-class="`adp-modal-body`" v-if="Object.keys(activities).length">
      <template #modal-header-close>
        <button type="button" class="close adp-close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
        </button>
      </template>
      <template>
        <div class="mass-assignments-alert">
          <p class="mass-assignments-alert__title">{{ $t('catalog.was_assign_assignments') }}</p>
          <div v-for="(activityUsers, activityKey) in userAssignments" v-if="userAssignments.length">
            <p class="mass-assignments-alert__subtitile">{{ activities[activityKey].name }}</p>
            <p v-for="(user, index) in activityUsers" class="mass-assignments-alert__item">
              {{ user.surname }} {{ user.name }} ({{ user.pernumber }})
            </p>
          </div>
        </div>
      </template>
    </b-modal>

    <assignments-view-modal :activity-id="Number(idForAssignmentsModal)"
                            :activity-name="assignedActivitiesText"
                            v-if="viewAssignmentsModal"
    />

    <div v-for="(activity, i) in Object.values(activities)" :key="i" v-if="Object.keys(activities).length">
      <mass-deadline-modal :activity="activity" :activity-index="i" :employee-pernumbers="employeePernumbers"
                           :activities-group="group"/>
    </div>
  </div>

</template>

<script>

import StructureTree from "../StructureTree";
import ActivityTypeSelect from "../ActivityTypeSelect";
import AssignmentsViewModal from "./AssignmentsViewModal";
import MassDeadlineModal from "./MassDeadlineModal";
import api from "../../api";

export default {
  name: "MassAssignmentModal",
  components: {
    AssignmentsViewModal,
    StructureTree,
    ActivityTypeSelect,
    MassDeadlineModal,
  },
  props: {
    learningActivityIds: {
      type: Object,
      required: true,
    },
    learningActivity: {
      type: Object,
      required: false,
    },
    groups: {
      type: Array,
      required: false,
    },
    group: {
      type: String,
      required: false,
    },
  },
  data: function () {
    return {
      assignedActivitiesText: '',
      userAssignments: {},
      search: '',
      errorText: '',
      noUsersError: false,
      companies: {},
      partialChecked: false,
      allChecked: false,
      checkedItems: {},
      activities: {},
      selectedGroup: this.group,
      employeePernumbers: [],

      idForAssignmentsModal: 0,

      viewAssignmentsModal: false,
    }
  },
  created() {
    if(this.learningActivity.activityId) {
      this.activities = {};
      this.activities[this.learningActivity.activityId] = this.learningActivity;
    } else {
      this.activities = this.learningActivityIds;
    }

    axios.get(window.IDP.role + '/structure').then(response => {
      if (response.data.departments && Object.keys(response.data.departments).length) {
        this.companies = Object.assign({}, response.data.departments);
      } else {
        this.noUsersError = true;
      }

      for (let [key, value] of Object.entries(this.companies)) {
        let checked = false;
        let changed = false;

        this.checkedItems[value.id] = {
          partialChecked: false, items: {}, id: value.id,
          checked: checked, changed: changed,
          inSearch: false, itemsSearch: false,
          showMobile: true, itemsOpenMobile: false,
          type: value.type, name: value.name,
        }
      }
    });
  },
  watch: {
    search: function () {
      this.noUsersError = false;
    },
    learningActivityIds() {
      this.activities = this.learningActivityIds;
    },
    learningActivity() {
      this.activities = {};

      if(Object.keys(this.learningActivity).length) {
        this.activities[this.learningActivity.activityId] = this.learningActivity;
      } else {
        this.activities = this.learningActivityIds;
      }
    }
  },
  methods: {
    toggleCheckedSearch() {
      this.allChecked = !this.allChecked;

      _.each(this.checkedItems, (item) => {
        item.checked = this.allChecked;
      });
    },

    updateItemsSearch() {

    },

    toggleMobile(id, open) {
      this.partialChecked =
      _.each(this.checkedItems, (item) => {
        if(id !== item.id) {
          item.showMobile = open;
        }
      });
      this.checkedItems = Object.assign({}, this.checkedItems);
    },

    async close() {
      await this.$bvModal.hide('mass-assignments-modal');
      $('.adp-navbar').removeClass('adp-navbar-fixed');
      await this.$emit('close-modal');
    },

    selectType(group) {
      this.selectedGroup = group;
    },

    updateItemsChecked() {
      const length = Object.keys(this.checkedItems).length;

      const checkedItems = Object.values(this.checkedItems).filter(function (item) {
        return item.checked;
      });

      const partialCheckedItems = Object.values(this.checkedItems).filter(function (item) {
        return item.partialChecked;
      });

      this.partialChecked = (checkedItems.length && checkedItems.length !== length) || partialCheckedItems.length;

      if (checkedItems.length && checkedItems.length === length) this.allChecked = true;
      if (!checkedItems.length && !partialCheckedItems.length) this.allChecked = false;
    },

    checkAssign() {
      let checked = this.getCheckedItems(this.checkedItems);

      if(!checked.length) {
        return;
      }

      axios.post(window.IDP.role + '/structure/assignments', {
        users: checked,
        activities: this.activities
      }).then(() => this.setDeadlines(checked));
    },

    async setDeadlines(checkedUsers) {
      await this.updateActivitiesData();
      const allUsersRes = await axios.get('/search');
      const allUsers = allUsersRes.data.data;
      const selectedUsers = [];
      const selectUsersFromStructures = [];
      Object.values(checkedUsers).forEach(item => {
        if (item.type !== 'user') {
          if (item.type === 'division') selectUsersFromStructures.push(allUsers.filter(x => x.division === item.id).map(x => x.pernumber));
          if (item.type === 'subdivision') selectUsersFromStructures.push(allUsers.filter(x => x.subdivision === item.id).map(x => x.pernumber));
          if (item.type === 'company') selectUsersFromStructures.push(allUsers.filter(x => x.company === item.id).map(x => x.pernumber));
          if (item.type === 'department') selectUsersFromStructures.push(allUsers.filter(x => x.department === item.id).map(x => x.pernumber));
        }
        if (item.type === 'user') selectedUsers.push(Number(item.id));
      })
      this.employeePernumbers = [...selectedUsers, ...selectUsersFromStructures.flat()];
      this.$bvModal.show('mass-deadlines-modal');
    },
    updateActivitiesData() {
      Object.values(this.activities).forEach(async (activity) => {
        const res = await api.getLearningActivity(activity.activityType, activity.activityId);
        const activityData = res.data;
        activity.start_at = activityData.start_at;
        activity.end_at = activityData.end_at;
      })
    },

    assign(checked) {
      axios.put(window.IDP.role + '/structure/assignments', {
        group: this.selectedGroup,
        users: checked,
        activities: this.activities
      }).then(response => {
        this.$bvModal.hide('mass-assignments-modal');
        $('.adp-navbar').removeClass('adp-navbar-fixed');
      });
    },

    getCheckedItems(items) {
      let checked = []

      Object.keys(items).forEach(key => {
        if (items[key].checked && !items[key].partialChecked) {
          checked.push({'type': items[key].type, 'id': items[key].id})
        }

        if (items[key].items && Object.keys(items[key].items).length && items[key].partialChecked) {
          let itemChecked = this.getCheckedItems(items[key].items)
          checked = checked.concat(itemChecked)
        }
      });

      return checked;
    },
    goToAssignments() {
      this.viewAssignmentsModal = true;
      this.idForAssignmentsModal = Object.values(Object.values(this.userAssignments)[0])[0].idps_learning_activity_id;

      $('.adp-navbar').removeClass('adp-navbar-fixed');
      this.$bvModal.hide('mass-assignments-modal');
      this.$bvModal.hide('alert-assignments-modal');
      this.$bvModal.hide('alert-assignments-modal-list');
      this.$nextTick(() => this.$bvModal.show('assignment-view-modal'));
      this.viewAssignmentsModal = false;
    }
  },
}
</script>

<style>
.adp-filter-input--no-result {
  padding-left: 24px;
  margin-top: 20px;
  font-size: 16px;
}

.notifications-error {
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 25px;
}
</style>
